import {useState,useRef } from "react";
import {Box, Typography} from "@mui/material";
import { COLORS } from "../../../dashboard/epis-dashboard/configs/config";
import Legenda from "./Legenda";
import Card from "./Card";

export default function RetiradaExtragrafico({data, todos, loading}){
   const totalregistros = todos > 0;
    
const STATUS = [
    { key: "pendente", label: "Pendente", cor: "#FFA500" },
    { key: "retirado", label: "Retirado", cor: "#008000" },
    { key: "aceito", label: "Aceito", cor: "#2196F3" },
    { key: "inativado", label: "Inativado", cor: "#CCCCCC" },
    { key: "negado", label: "Negado", cor: "#FF0000" },
];
    const fmt = (n) => (n ?? 0).toLocaleString("pt-BR");
    const [hover, setHover] = useState(null);
    const [pos, setPos] = useState({ x: 0, y: 0 });
    const boxRef = useRef(null);

    const fatias = STATUS.map((s) => ({ ...s, valor: data?.[s.key] ?? 0 }));
    const total = fatias.reduce((s, f) => s + f.valor, 0);
    const cx = 90, cy = 90, R = 80;

    let ang = -Math.PI / 2;
    const arcos = fatias.map((f) => {
        const frac = total ? f.valor / total : 0;
        const ini = ang;
        ang += frac * 2 * Math.PI;
        const pt = (a) => `${cx + R * Math.cos(a)},${cy + R * Math.sin(a)}`;
        const d = frac >= 0.9999 ? null : `M${cx},${cy} L${pt(ini)} A${R},${R} 0 ${frac > 0.5 ? 1 : 0} 1 ${pt(ang)} Z`;
        return { ...f, frac, d };
    });

    const onMove = (e) => {
        const rect = boxRef.current.getBoundingClientRect();
        setPos({ x: e.clientX - rect.left, y: e.clientY - rect.top });
    };
    const ativo = hover != null ? arcos[hover] : null;

    return (
        <>
        {totalregistros ? (
        <Card title="Retirada extra" subtitle="Agrupada por status">
            <Box ref={boxRef} onMouseMove={onMove} onMouseLeave={() => setHover(null)} sx={{ position: "relative", display: "flex", justifyContent: "center" }}>
                <svg viewBox="0 0 180 180" width="190" height="190" role="img" aria-label="Retirada extra por status">
                    {total === 0 && <circle cx={cx} cy={cy} r={R} fill={COLORS.kpiBg} />}
                    {arcos.map((a, i) =>
                        a.frac === 0 ? null : a.d ? (
                            <path key={a.key} d={a.d} fill={a.cor} stroke="#fff" strokeWidth="2" opacity={hover == null || hover === i ? 1 : 0.55} onMouseEnter={() => setHover(i)} style={{ transition: "opacity .15s", cursor: "pointer" }} />
                        ) : (
                            <circle key={a.key} cx={cx} cy={cy} r={R} fill={a.cor} onMouseEnter={() => setHover(i)} style={{ cursor: "pointer" }} />
                        )
                    )}
                </svg>
                {ativo && (
                    <Box sx={{ position: "absolute", left: pos.x + 12, top: pos.y + 12, pointerEvents: "none", bgcolor: "#1f2d2a", color: "#fff", px: 1.25, py: 0.75, borderRadius: 1, fontSize: 12, whiteSpace: "nowrap", zIndex: 2 }}>
                        <strong>{ativo.label}</strong>
                        <br />
                        {fmt(ativo.valor)} retiradas · {(ativo.frac * 100).toFixed(1).replace(".", ",")}%
                    </Box>
                )}
            </Box>
            <Legenda itens={fatias}  />
        </Card>
        ) : (
            <Card title="Retirada extra" subtitle="Agrupada por status" loading={loading}>
                <Typography display={"flex"} justifyContent={"center"}>Nenhum dado encontrado</Typography>
            </Card>
        )}
        </>
    );
}